export default __webpack_public_path__ + "static/media/what_we_do_2.ff1e0a57.svg";